/*
 * @Author: o.xiewanqing
 * @Date: 2025-08-06 10:06:03
 * @LastEditors: o.xiewanqing
 * @LastEditTime: 2025-08-09 20:01:49
 * @Description: 将store里的初始公参拼接到跳转链接
 */
import { mapGetters } from 'vuex';
import { pick } from 'lodash-es';
import { appendObjectToUrl, getQueryAll } from '@hll/eapp-utils';

// 删除url所有查询参数（同时移除 search 和 hash 中的查询串，保留原始相对/绝对形式）
const removeAllParams = (url) => {
  try {
    // 保留原始的相对/绝对写法，不使用 URL 构造器
    // 1) 去除 search 中的查询
    const [beforeHash, rawHash = ''] = url.split('#');
    const basePath = beforeHash.split('?')[0];

    // 2) 去除 hash 中可能携带的查询
    const cleanHash = rawHash ? rawHash.split('?')[0] : '';

    return cleanHash ? `${basePath}#${cleanHash}` : basePath;
  } catch (e) {
    console.error('removeAllParams error:', e);
    return url;
  }
};

export default {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapGetters(['queryParams']),
      },
      methods: {
        /**
         * 将store里的初始公参拼接到跳转链接
         * @param {String} url 原链接
         * @param {Array<String>} allowedKeys 必传，允许拼接的字段白名单，如 ['token']
         * @param {Record<string, any>} extraParams 额外添加的参数
         * @param {Boolean} filterEmpty 是否过滤参数中的空值
         */
        appendQueryParams(url, config) {
          if (!url) return url;
          const initQueryParams = this.queryParams;
          const { allowedKeys, extraParams = {}, filterEmpty = true } = config || {};
          try {
            const queryAll = getQueryAll(url);
            const pickedInit = pick(initQueryParams, allowedKeys);
            const uniqueParams = {
              ...queryAll,
              ...pickedInit,
              ...extraParams,
            };
            const newUrl = removeAllParams(url);
            // appendObjectToUrl内含encodeURIComponent处理，无需自行加密
            return appendObjectToUrl(newUrl, uniqueParams, filterEmpty);
          } catch (error) {
            console.error('appendQueryParams error:', error);
            return url;
          }
        },
      },
    });
  },
};
